import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { LeftpanelComponent } from '../leftpanel/leftpanel.component';

@Component({
  selector: 'app-leftpanelnewdesign',
  templateUrl: './leftpanelnewdesign.component.html',
  styleUrls: ['./leftpanelnewdesign.component.css']
})
export class LeftpanelnewdesignComponent {

  @Input() handleCheckboxClick: ((event: MouseEvent) => void) | undefined;
  @Input() moduleList: any = [];
  @Input() selectedScenarioData: any;
  @Input() output_data: any;
  @Input() dataArray: any;
  @Input() isSavedScenarioSelected: boolean = false;
  @Input() isCustomSnapshot: boolean = true;
  @Output() showOutput = new EventEmitter<void>();
  @Output() snapNameNavHeader = new EventEmitter<any>();
  @Output() selectedType = new EventEmitter();
  @Output() baseValuesChanged = new EventEmitter<{ insufficientBase: number, lowBase: number }>();
  @Output() dataListChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() isSubmitReset: boolean = false;
  @Output() isLoadSelection = new EventEmitter<boolean>();




  @ViewChild(forwardRef(() => LeftpanelComponent)) child!: LeftpanelComponent;

  // ngAfterViewInit() {
  // }
  isfilterSelected = true;
  isSavedSelectionSelected = false;
  isFeaturesSelected = false;

  sectionSelected(section: string) {
    if (section === 'filter') {
      this.isfilterSelected = true;
      this.isSavedSelectionSelected = false;
      this.isFeaturesSelected = false;
      this.isSubmitReset=false;
    } else if (section === 'savedSelection') {
      this.isfilterSelected = false;
      this.isSavedSelectionSelected = true;
      this.isFeaturesSelected = false;
      this.child.LoadSelection(false);
    } else if (section === 'features') {
      this.isfilterSelected = false;
      this.isSavedSelectionSelected = false;
      this.isFeaturesSelected = true;
    }
  }

  ShowOutput() {
    this.showOutput.emit();
  }

  snapHeaderNameFun($event: any) {
    this.snapNameNavHeader.emit($event);
  }
  
  selectedTypeFun2($event: any) {
    this.selectedType.emit($event);
  }

  onBaseValuesChanged($event: { insufficientBase: number; lowBase: number }) {
    this.baseValuesChanged.emit($event);
  }

  dataListChangeFun($event: any) {
    this.dataListChange.emit($event);
  }

  submitReset($event: any) {
    this.isSubmitReset = $event;
  }

  ResetClicked(){
    this.child.ResetClicked();
  }

  SubmitClicked(){
    this.child.SubmitClicked(false);
  }

  LoadSelection($event: any){
    this.isLoadSelection.emit($event);
  }

}


